import { Injectable } from '@angular/core';
declare var bootstrap: any;


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  mostrarNotificacion(mensaje: string, tipo: 'success' | 'error' | 'info' | 'warning'): void {
    const toastEl = document.getElementById('notificacionToast');
    if (toastEl) {
      // Determinar la clase de estilo basada en el tipo de notificación
      let bgClass;
      switch (tipo) {
        case 'success':
          bgClass = 'success';
          break;
        case 'error':
          bgClass = 'danger';
          break;
        case 'info':
          bgClass = 'info';
          break;
        case 'warning':
          bgClass = 'warning';
          break;
        default:
          bgClass = 'secondary'; // Clase por defecto
      }

      // Configurar las clases del elemento toast
      toastEl.className = `toast align-items-center text-bg-${bgClass} position-fixed top-0 end-0 p-3`;
      toastEl.querySelector('.toast-body')!.innerHTML = mensaje;

      // Mostrar el toast
      const toast = new bootstrap.Toast(toastEl);
      toast.show();
    }
  }

}
